import React from 'react';
import { Spin, Table, Tooltip, Button, Icon, Input, Col, Row, Modal, Select, Alert } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import SustitucionDemandaRequest from '../../services/SustitucionDemanda';
import FormSustitucionDemanda from './FormSustitucionDemanda';
import CatalogosRequest from '../../services/Catalogos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';
const { confirm } = Modal;
const { Option } = Select;

/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class SustitucionDemanda extends BaseComponent {
    state = {
        arrSustituciones: [],
        arrSustitucionesCopy: [],
        filterText: "",
        cargando: false,
        modo: null,
        tipo_modal: null,
        modalEquivalencias: false,
        sustitucionSelected: null,
        disableApplyFilters: true,
        disableCreateMinimo: true,
        disableDeleteFilters: true,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        arrSegmentos: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        segmentoSelected: null,
        drivesSelected: [],
        erroresTabla: [],
        showModalErrores: false,
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                return CatalogosRequest.ListarSegmentosConfigurados()
            })
            .then(response => {
                state.arrSegmentos = response.data;
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Función que se ejecuta para cargar las equivalencias
     */
    cargarSustituciones = () => {
        let state = { ...this.state }
        state.cargando = true
        state.filterText = "";
        state.disableCreateMinimo = false;
        this.setState(state, () => {
            SustitucionDemandaRequest.ListarSustitucionDemanda(state.drivesSelected.toString())
                .then(response => {
                    state.arrSustituciones = response.data
                    state.arrSustitucionesCopy = response.data
                    state.cargando = false
                    this.setState(state)

                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar las sustituciones.",
                        "Error al listar sustituciones",
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrSustitucionesCopy = state.arrSustituciones
        if (value) {
            arrSustitucionesCopy = arrSustitucionesCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo_anterior.codigo)
                    || sanitizerTexto(value, obj.articulo_anterior.descripcion)
                    || sanitizerTexto(value, obj.articulo_anterior.unidad_compra)
                    || sanitizerTexto(value, obj.articulo_nuevo.codigo)
                    || sanitizerTexto(value, obj.articulo_nuevo.descripcion)
                    || sanitizerTexto(value, obj.articulo_nuevo.unidad_compra)
            })
        }
        state.arrSustitucionesCopy = arrSustitucionesCopy
        this.setState(state);
    }

    /**
     * Función para mostar el modal de categorización
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalEquivalencias: true })
    }

    /**
     * Función para esconder modal de categorización
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.modalEquivalencias = false;
        state.sustitucionSelected = null;
        state.erroresArchivo = [];
        this.setState(state)
        if (value) this.cargarSustituciones()
    }

    /**
     * Comportamiento al confirmar eliminar clendario
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar la sustitución?</b> Se borrará la sustitución definitivamente.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-sustitucion-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-sustitucion-form',
            },
            onOk: () => {
                this.setState({ cargando: true })
                SustitucionDemandaRequest.EliminarSustitucion(this.state.sustitucionSelected.id)
                    .then(response => {
                        this.setState({ sustitucionSelected: null })
                        openNotification(
                            "Se ha eliminado correctamente la sustitución.",
                            "Sustitución eliminada correctamente",
                            true
                        )
                        this.cargarSustituciones();
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(
                            err.response.data.cuerpo,
                            "Error al eliminar sustitución",
                            false
                        )
                    })
            },
            onCancel: () => {
                this.setState({ sustitucionSelected: null, modo: null })

            }
        });
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.filterText = '';
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.disableDeleteFilters = true;
        state.segmentoSelected = null;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrSustituciones = [];
        state.arrSustitucionesCopy = [];
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.disableApplyFilters = true;
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.drivesSelected = [];
        state.disableCreateMinimo = true;
        state.arrSustituciones = [];
        state.arrSustitucionesCopy = [];
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.segmentoSelected = null;
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.arrSustituciones = [];
        state.arrSustitucionesCopy = [];
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.segmentoSelected = null;
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.arrSustituciones = [];
        state.arrSustitucionesCopy = [];
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
        }

        this.setState(state)
    }

    /**
     * Función que se cambia el segmento
     * @param: value. valor del id del segmento
     * @return: nada.
     */
    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.filterText = "";
        state.disableApplyFilters = true
        state.disableCreateMinimo = true;
        if (value === undefined) {
            state.segmentoSelected = null;
        } else {
            state.segmentoSelected = value
            if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                CatalogosRequest.ListarSitios(state.plazaSelected, value).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            } else {
                CatalogosRequest.ListarSitiosPlazaUsuario(value, localStorage.getItem("id_user")).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            }
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.arrSustituciones = [];
        state.arrSustitucionesCopy = [];
        state.disableCreateMinimo = true;
        if (!value.length) {
            state.drivesSelected = [];
            state.disableApplyFilters = true
        } else {
            state.drivesSelected = value
            state.disableApplyFilters = false
        }

        this.setState(state)
    }

    /**
     * Función para esconder el modal para mostrar errores
     * Restablece algunos de los valores para el estado del componente
     * @param {} :
     * @return {} :
     */
    handleCancelModalErrores = () => {
        let state = { ...this.state };
        state.showModalErrores = false;
        state.erroresTabla = [];
        this.setState(state);
    }

    /**
     * Función para esconder el modal para mostrar errores
     * Restablece algunos de los valores para el estado del componente
     * @param {} :
     * @return {} :
     */
    MostrarModalErrores = (error) => {
        let state = { ...this.state };
        state.erroresTabla = error
        this.setState(state, () => {
            this.setState({
                modalEquivalencias: false,
                showModalErrores: true
            })
        })
    }

    render() {
        const columnasCategorias = [
            {
                title: 'Artículo anterior',
                children: [
                    {
                        title: "Código",
                        dataIndex: "articulo_anterior.codigo",
                        key: "articulo_anterior.codigo"
                    },
                    {
                        title: "Descripción",
                        dataIndex: "articulo_anterior.descripcion",
                        key: "articulo_anterior.descripcion"
                    },
                    {
                        title: "Unidad de compra",
                        dataIndex: "articulo_anterior.unidad_compra",
                        key: "articulo_anterior.unidad_compra"
                    },
                ]
            },
            {
                title: 'Artículo nuevo',
                children: [
                    {
                        title: "Código",
                        dataIndex: "articulo_nuevo.codigo",
                        key: "articulo_nuevo.codigo"
                    },
                    {
                        title: "Descripción",
                        dataIndex: "articulo_nuevo.descripcion",
                        key: "articulo_nuevo.descripcion"
                    },
                    {
                        title: "Unidad de compra",
                        dataIndex: "articulo_nuevo.unidad_compra",
                        key: "articulo_nuevo.unidad_compra"
                    },
                ]
            },
            {
                title: '',
                children: [
                    {
                        title: "Factor",
                        dataIndex: "factor_conversion",
                        key: "factor_conversion",
                        render: factor_conversion => (
                            <span>{factor_conversion.toFixed(4)}</span>
                        )
                    },
                    {
                        title: "Sitio",
                        dataIndex: "nombre_sitio",
                        key: "nombre_sitio"
                    },
                    {
                        title: 'Acciones',
                        dataIndex: 'Acciones',
                        key: 'Acciones',
                        render: (value, record) => (
                            <div>
                                <div>
                                    <span style={{ marginRight: 5 }}>
                                        <Tooltip placement="top" title={"Editar sustitución"}>
                                            <Button
                                                id="boton-editar-sustitucion-row"
                                                icon="edit"
                                                className="btnEditar"
                                                onClick={() => {
                                                    this.setState({
                                                        sustitucionSelected: record,
                                                        modo: "editar",
                                                        tipo_modal: 'uno'
                                                    }, this.showModal())
                                                }}
                                            >
                                            </Button>
                                        </Tooltip>
                                    </span>
                                    <span style={{ marginRight: 5 }}>
                                        <Tooltip placement="top" title={"Eliminar sustitución"}>
                                            <Button
                                                id="boton-eliminar-sustitucion-row-modulo"
                                                icon="delete"
                                                className="btnEditar"
                                                onClick={() => {
                                                    this.setState({
                                                        sustitucionSelected: record,
                                                        modo: 'eliminar'
                                                    }, this.showConfirmDelete)
                                                }}
                                            >
                                            </Button>
                                        </Tooltip>
                                    </span>
                                </div>
                            </div>
                        )
                    }
                ]
            },

        ]

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo sustitución de demanda"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            disabled={this.state.disableCreateMinimo}
                            type="primary"
                            id="boton-nueva-sustitucion-modulo"
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'dos' }, () => {
                                    this.showModal();
                                })

                            }}
                        >
                            Nueva sustitución
                        </Button>
                    </div>
                }>

                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Región:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una región">
                                    <Select
                                        id="select-region-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                        value={this.state.regionSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Sucursal:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una sucursal">
                                    <Select
                                        id="select-sucursal-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.regionSelected === null ? true : false}
                                        onChange={this.handleChangeSucursal}
                                        value={this.state.sucursalSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Plaza:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una plaza">
                                    <Select
                                        id="select-plaza-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected === null ? true : false}
                                        onChange={this.handleChangePlaza}
                                        value={this.state.plazaSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Segmento:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione un segmento">
                                    <Select
                                        id="select-segmento-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeSegmento}
                                        value={this.state.segmentoSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSegmentos.length > 0 &&
                                            this.state.arrSegmentos.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Punto de venta:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione punto de venta">
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        mode="multiple"
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.segmentoSelected === null ? true : false}
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <Tooltip placement="top" title={this.state.plazaSelected !== null ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-prductos-minimo"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.cargarSustituciones}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <Tooltip placement="top" title="Borrar filtros">
                                    <Button
                                        id="boton-borrar-filtros-prductos-minimo"
                                        type="default"
                                        icon="delete"
                                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                        style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.cleanFilters}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className={this.state.arrSustituciones.length ? '' : 'display-none'}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por cualquier columna">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-sustitucion-modulo"
                                        placeholder="Buscar por cualquier columna"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={categoria => categoria.id}
                            columns={columnasCategorias}
                            dataSource={this.state.arrSustitucionesCopy}
                            bordered
                            pagination={{ showTitle: false }}
                        />
                    </Spin>
                    <Modal
                        title={<p style={{ textAlign: "center", marginBottom: 0 }}>Error al guardar sustitución de demanda</p>}
                        centered={true}
                        maskClosable={false}
                        width={"35%"}
                        visible={this.state.showModalErrores}
                        footer={
                            <div>
                                <Button onClick={this.handleCancelModalErrores}>
                                    <b>Regresar</b>
                                </Button>
                            </div>
                        }
                        onCancel={this.handleCancelModalErrores}
                    >
                        <div style={{ width: "100%", textAlign: "center", marginTop: "5px" }}>
                            <p>Favor de quitar los siguientes drives de la selección para continuar con la sustitución.</p>
                        </div>
                        <div style={{ maxHeight: "500px", overflowY: "scroll" }}>
                            {
                                this.state.erroresTabla?.length > 0 &&
                                this.state.erroresTabla?.map((error, index) => {
                                    return (
                                        <Alert
                                            key={index}
                                            message={error}
                                            type="error"
                                            showIcon
                                            style={{ marginTop: "5px", marginBottom: "5px" }}
                                        />
                                    )
                                })
                            }
                        </div>
                    </Modal>
                </div>
                <FormSustitucionDemanda
                    esconderModal={this.esconderModal}
                    visible={this.state.modalEquivalencias}
                    mostrarErrores={this.MostrarModalErrores}
                    type={this.state.tipo_modal}
                    modo={this.state.modo}
                    drive_selected={this.state.drivesSelected}
                    sustitucion_selected={this.state.sustitucionSelected}
                >
                </FormSustitucionDemanda>
            </ResponsiveCard>
        )
    }
}